import React, { useState } from 'react';

export type IPageState = {
  pageTitle: string;
  setPageTitle: (pageTitle: string) => void;
  isOpenAlert: boolean;
  setIsOpenAlert: (flag: boolean) => void;
}

export const PageContext = React.createContext<IPageState>({} as IPageState);

export const PageContextProvider = (props: any) => {
  const [pageTitle, setPageTitle] = useState<string>('');
  const [isOpenAlert, setIsOpenAlert] = useState(false); 

  return (
    <PageContext.Provider
      value={{
        pageTitle,
        setPageTitle,
        isOpenAlert,
        setIsOpenAlert,
      }}
    >
      {props.children}
    </PageContext.Provider>
  )
}